<div class="layer create-video-layer collapsed">
  <div class="row">
    <div class="col-md-3">
      <div class="layer-title">
        <div class="new-layer">
          <input type="text" (keyup.enter)="accept()" #input class="form-control new-layer-input" [(ngModel)]="newLayer.title" placeholder="New Layer Name"/>
        </div>
        <div class="collapse-btn"></div>
        <div class="actions">
          <i class="accept" [ngClass]="{'disabled' : !newLayer.title }" (click)="accept()"></i><i (click)="decline()" class="decline"></i>
        </div>
      </div>
    </div>

    <div class="col-md-9">
      <div class="clips"></div>
    </div>

  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/timeline/create-video-layer/create-video-layer.component.html